import React from "react"

type Props = {}

export default function Reviews({}: Props) {
  return <div>Reviews</div>
}
